import { render } from "./format-selector.vue?vue&type=template&id=16c522e2&scoped=true"
import script from "./format-selector.vue?vue&type=script&lang=js"
export * from "./format-selector.vue?vue&type=script&lang=js"

import "./format-selector.vue?vue&type=style&index=0&id=16c522e2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\gurmi\\Projects\\anyform\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c522e2"]])

export default __exports__